<div id="shell-wrapper">
  <router-outlet></router-outlet>
</div>
